import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { FaFileAlt } from "react-icons/fa";
const Item = ({
  item,

  moduleConfig,

  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
  confirmAndDelete,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.email) {
      items = [
        ...items,
        {
          text: "Email",
          value: item.email,
          type: "email",
        },
      ];
    }
    if (item.mobile) {
      items = [
        ...items,
        {
          text: "mobile",
          value: item.mobile,
          type: "phone",
        },
      ];
    }
    if (item.noticePeriod) {
      items = [
        ...items,
        {
          text: "Notice Period",
          value: item.noticePeriod,
          type: "number",
        },
      ];
    }
    // if (item.description) {
    //   items = [
    //     ...items,
    //     { text: "Description", value: item.description, type: "text" },
    //   ];
    // }

    return items;
  };
  return (
    <Card className="item mb-2 borderCream">
      {/* {console.log(item)} */}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex align-items-center ImageSectionSpacing">
            <div className="me-2 ms-1">
              <FaFileAlt size={30} />
            </div>

            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                {item.firstName + " " + item.lastName}
              </span>

              <span className="">
                <span className="text-custom-4 mt-1 small ">
                  Applied for -{" "}
                  <span className="text-custom-3 text-bold">
                    "{item.job.title}"
                  </span>
                </span>
              </span>
            </div>
          </div>
        </Card.Title>

        <div className="card-tools endColumn mb-1 pt-1">
          <div>
            <span className=" me-1 text-dark"></span>
            {item.appliedDate && (
              <span className="badge badge-light me-1 text-dark">
                Applied Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.appliedDate} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>

            <span
              title={`Delete ${moduleConfig.singleItemTitle}`}
              onClick={() => confirmAndDelete(item._id)}
              className="btn btn-outline-secondary listingActionIcon"
            >
              <i className="fas fa-trash"></i>
            </span>
            <a
              href={process.env.REACT_APP_BACKEND_URL + "public/" + item.file}
              download
              target="_blank"
              className="btn btn-outline-secondary listingActionIcon"
              title="Download resume"
            >
              <i className="fas fa-download"></i>
            </a>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col md={12} className="mt-1 mb-1">
            <StatsListing items={getItems()} />
          </Col>
        </Row>
        {/* <Row>
          <Col className="">
            {item.message && (
              <Alert className="alert-custom-3 d-flex mb-1  flex-wrap p-1 font-small">
                <strong className="me-1 mt-1 text-custom-1">Message:</strong>
                <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                  <span
                    className="font-small text-normal text-custom-1 html"
                    dangerouslySetInnerHTML={{ __html: item.message }}
                  ></span>
                </div>
              </Alert>
            )}
          </Col>
        </Row> */}
      </Card.Body>
    </Card>
  );
};

export default Item;
